// extracted by mini-css-extract-plugin
module.exports = {"exchangeCardRoot":"BC6T5q7r","details":"EZ66lNSX","title":"FguZlV7o","subtitle":"jaOTciTh","country":"Mjn9W0yM"};